<template>
  <span v-if="actionData.disabled" :class="buttonClass + ' text-black text-opacity-25'">
    <i :class="actionData.iconClass + ' fs-5 text-black text-opacity-25'" style="font-size: 1em"></i
    ><span v-if="showName">&nbsp;{{ actionData.name }}</span>
  </span>
  <span
    v-else-if="actionData.confirm"
    :class="buttonClass"
    style="cursor: pointer; white-space: nowrap; color: var(--link-color)"
  >
    <i
      :class="actionData.iconClass"
      :data-url="getTargetRoute(route, routePrefix, options?.params ?? {})"
      style="font-size: 1em"
      @click="confirmAction($event, trans)"
    ></i
    ><span v-if="showName">&nbsp;{{ actionData.name }}</span>
  </span>
  <button
    v-else-if="action === 'pick'"
    :class="buttonClass"
    class="btn-icon"
    style="background-color: transparent; border: none; cursor: pointer; white-space: nowrap; color: var(--link-color)"
    type="button"
    @click="updatePicked()"
  >
    <i :class="actionData.iconClass" style="font-size: 1em"></i>
  </button>
  <Link
    v-else
    :class="buttonClass"
    :href="getTargetRoute(route, routePrefix, options?.params ?? {})"
    style="white-space: nowrap"
  >
    <i :class="actionData.iconClass" style="font-size: 1em"></i><span v-if="showName">&nbsp;{{ actionData.name }}</span>
  </Link>
</template>

<script>
import { Link, router } from '@inertiajs/vue3';

export default {
  components: {
    Link,
  },
  props: {
    action: { type: String, default: null },
    actionData: {
      type: Object,
      default: () => ({
        iconClass: null,
        name: null,
        disabled: null,
        relation: null,
      }),
    },
    buttonClass: { type: String, default: null },
    showName: { type: [Boolean, String], default: false },
    model: { type: Object, default: () => {} },
    resourceType: { type: String, default: null },
    options: { type: Object, default: () => {} },
  },
  emits: ['updatePicked'],
  setup(props, { emit }) {
    const getTargetRoute = (route, routePrefix, params = {}) => {
      params['id'] = props.model.data?.id;
      return route(`${routePrefix}.${props.resourceType}.${props.action}`, params);
    };

    const confirmAction = (event, trans) => {
      if (!confirm(trans(props.actionData.confirm.translation.text, props.actionData.confirm.translation.params))) {
        return;
      }

      router.delete(event.target.dataset.url, {}, { preserveState: true, only: ['models'], replace: true });
    };

    const updatePicked = () => {
      emit('updatePicked', props.model);
    };

    return {
      confirmAction,
      getTargetRoute,
      updatePicked,
    };
  },
};
</script>
